export default __webpack_public_path__ + "static/media/logout.66a76de8.svg";